import React, { useEffect, useState, useRef, useCallback } from 'react';
import styled from 'styled-components';
import HtmlParser from '../HtmlParser/HtmlParser';
import { fontstack } from '../../utils/fontstack';
import { type } from '../../utils/type';
import { media } from '../../utils/mediaQuery';
import Icon from './assets/x.svg';

const Wrapper = styled.div`
  position: relative;
  width: 100%;

  ${({border}) => border && `
    border-top: 1px solid #383B23;
  `}
  
`

const Accordion = (props) => {
  const { children, defaultIndex, border, initActive, ...rest } = props;
  const [ Active, setActive ] = useState(initActive); 
  const [ WrapperRef, setWrapperRef ] = useState();

  useEffect(() => {

    if(WrapperRef) {
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
      
         if(entry.intersectionRatio === 0 ){
            onClose();
          } 
          
    
        }); 

      }, { threshold: 0 })

      observer.observe(WrapperRef);
    }
    

  }, [WrapperRef])

  const onSelect = (index) => {
    setActive(index);
  }

  const onClose = () => {
    setActive(null);
  }

  const wrapperReference = useCallback((node) => {
    if(node !== null) {
      setWrapperRef(node);
    }
  },[])


  const Cards = React.Children.map(children, (child, index) => {
    if(React.isValidElement(child)) {
      return React.cloneElement(child,{ id: index, onSelect: onSelect, onClose: onClose, active: Active === index ? 1 : 0 });
    }
    return child;
  });

  return (
    <Wrapper ref={wrapperReference} border={border} {...rest}>
      {Cards}
    </Wrapper>
  )
}

export { Accordion };

const ItemCircle = styled.div`
  width: 13px;
  height: 13px;
  background: #383B23;
  border-radius: 50%;
  opacity: 0;
`

const ItemHollowCircle = styled(ItemCircle)`
  background: transparent;
  border: 1px solid #383B23;
`

const ItemWrapper = styled.div` 
  display: flex;

  ${ItemHollowCircle} {
    opacity: ${props => props.active ? '1' : '0'};
  }
`

const ItemInner = styled.div`
  padding: 20px 0;
  border-bottom: 1px solid #383B23;
  flex: 1;
`
const ItemIconCol = styled.div`
  width: 33%;
  padding: 0 0 0 10px;
  display: none;
  ${media.large`
    display: block;
  `}
`

const ItemCircleArray = styled.div` 
  position: absolute;
`

const ItemCircleWrapper = styled.div` 
  position: relative;
  top: 4px;
  margin: 20px 0;

`



const ItemButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
`

const ItemLabel = styled.div`
  ${fontstack.default}
  ${type('m-body')}
  color: #383B23;
  text-transform: uppercase;

  ${media.large`
    ${type('body')}
  `}
`

const ItemContent = styled.div`
   ${fontstack.default}
   ${type('m-body')}
    opacity: ${props => props.opacitynone ? '1' : '0.7'};
    overflow: hidden;
    height: ${props => props.active ? 'auto' : '0'};
    user-select: none;
    color: #383B23;

    ${media.large`
      ${type('body')}
      padding: ${props => props.hasPad ? '0 0 0 30px' : '0'};
    `}

    &:before {
      display: block;
      content: '';
      width: 100%;
      height: 20px;
    }
`

const ToggleIcon = styled(Icon)` 
  transform: rotate(${props => props.active ? '45deg' : '0deg'});
  transition: transform .2s ease;
  z-index: 1;

`

const AccordionItem = (props) => {
  const {id, label, children, active, onSelect, onClose, image, opacitynone, iconCol, posCallback, ...rest } = props; 
  const itemRef = useRef();


  const onMouseEnter = () => {
    if(posCallback) {
      posCallback(itemRef.current.getBoundingClientRect());
    }
  }

  return (
    <ItemWrapper active={active} ref={itemRef} onMouseEnter={onMouseEnter}>
      { iconCol ? <ItemIconCol>
          <ItemCircleArray>
          <ItemCircleWrapper><ItemCircle active={active}/></ItemCircleWrapper>
        <ItemCircleWrapper><ItemHollowCircle/></ItemCircleWrapper>
          </ItemCircleArray>
      </ItemIconCol> : null }
      <ItemInner>
        <ItemButton onClick={()=> active ? onClose() : onSelect ? onSelect(id) : null}><ItemLabel {...rest}>{label}</ItemLabel><ToggleIcon active={active}/></ItemButton>
        <ItemContent hasPad={!iconCol} active={active} opacitynone={opacitynone}>{image || null}<HtmlParser>{ children }</HtmlParser></ItemContent>
      </ItemInner>
    </ItemWrapper>
  )
}

export { AccordionItem };